import { useEffect } from 'react';
const defaultStyle = {
  position: 'fixed',
  inset: '0px',
  zIndex: 1010
};
export default ((isActive, customStyle, onClick) => {
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (isActive) {
      const el = document.createElement('div');
      Object.assign(el.style, defaultStyle, customStyle);
      el.dataset.testid = 'backdrop';
      document.body.appendChild(el);
      if (typeof onClick === 'function') {
        el.addEventListener('click', onClick);
      }
      return () => {
        document.body.removeChild(el);
      };
    }
  }, [isActive, customStyle, onClick]);
});